/* Local dependencies */
import type { AuthFields } from '../../redux/validateAuthFields';

export enum RegisterActionTypes {
  REGISTER_REQUEST = 'REGISTER_REQUEST',
  REGISTER_SUCCESS = 'REGISTER_SUCCESS',
  REGISTER_ERROR = 'REGISTER_ERROR',
  CLEAR_REGISTER_ERROR = 'CLEAR_REGISTER_ERROR',
  SET_REGISTRATION_FIELD = 'SET_REGISTRATION_FIELD',
}

export interface RegisterRequest {
  type: RegisterActionTypes.REGISTER_REQUEST;
  email: string;
  password: string;
  givenName: string;
  familyName: string;
  phone: string;
}

export interface RegisterSuccess {
  type: RegisterActionTypes.REGISTER_SUCCESS;
  email: string;
}

export interface RegisterError {
  type: RegisterActionTypes.REGISTER_ERROR;
  error: any;
}

export interface SetRegistrationField {
  type: RegisterActionTypes.SET_REGISTRATION_FIELD;
  field: keyof AuthFields;
  value: AuthFields[keyof AuthFields];
}

export function register(
  email: string,
  password: string,
  givenName: string,
  familyName: string,
  phone: string,
): RegisterRequest {
  return {
    type: RegisterActionTypes.REGISTER_REQUEST,
    email,
    password,
    givenName,
    familyName,
    phone,
  };
}

export function registerSuccess(email: string): RegisterSuccess {
  return {
    type: RegisterActionTypes.REGISTER_SUCCESS,
    email,
  };
}

export function registerFailed(error: any): RegisterError {
  return {
    type: RegisterActionTypes.REGISTER_ERROR,
    error,
  };
}

export function setRegistrationField(
  field: keyof AuthFields,
  value: AuthFields[keyof AuthFields],
): SetRegistrationField {
  return {
    type: RegisterActionTypes.SET_REGISTRATION_FIELD,
    field,
    value,
  };
}

export interface ClearRegisterError {
  type: RegisterActionTypes.CLEAR_REGISTER_ERROR;
}

export function clearRegisterError(): ClearRegisterError {
  return {
    type: RegisterActionTypes.CLEAR_REGISTER_ERROR,
  };
}

export type RegisterAction =
  | RegisterRequest
  | RegisterSuccess
  | RegisterError
  | ClearRegisterError
  | SetRegistrationField;
